'use strict'
import Highcharts from "highcharts/highstock";
import {
  formatNumber, extend_row_desc_foo, modalOpenHandler,
  modalCloseHandler, tabsHandler, ratesChart
} from "./bonds";
import $ from 'jquery';

function sort_by_key(array, key)
{
  return array.sort(function(a, b)
  {
    const x = a[key]
    const y = b[key]
    return ((x > y) ? -1 : ((x < y) ? 1 : 0))
  })
}
/* данные для графиков дюрации */
const seriesDataDuration = (row) =>
{
  const m_duration = parseFloat(row.duration != null ? row.duration : row.mod_duration)
  const yield_price_return = parseFloat(row.price_return)
  return [Number(m_duration), Number(yield_price_return)]
}
/* данные для графиков срока */
const seriesDataYTM = (row) =>
{
  const yield_price_return = parseFloat(row.price_return)
  return [Number(row.years_to_maturity), Number(yield_price_return)]
}

const qualityColor = (field) =>
{
  let inlineColorQuality = '#CCCCCC'
  if ( field >= 8 ) {
    inlineColorQuality = '#23dea8'
  }
  else if ( field >= 7 && field < 8 ) {
    inlineColorQuality = '#c5efdd'
  }
  else if ( field >= 5 && field < 7 ) {
    inlineColorQuality = '#ccdff1'
  }
  else if ( field >= 3 && field < 5 ) {
    inlineColorQuality = '#e8c9db'
  }
  else if ( field >= 1 && field < 3) {
    inlineColorQuality = '#ad033b'
  }
  return inlineColorQuality
}

const creditRatingTextColor = (field) =>
{
  let inlineColorCredRate = '#CCCCCC'
  switch (field) {
    case 'AAA': case 'AA':
      inlineColorCredRate = '#23dea8'; break;
    case 'A':
      inlineColorCredRate = '#3DEAB8'; break;
    case 'BBB':
      inlineColorCredRate = '#c5efdd'; break;
    case 'BB': case 'BB-':
      inlineColorCredRate = '#ccdff1'; break;
    case 'B+': case 'B': case 'B-':
      inlineColorCredRate = '#e8c9db'; break;
    case 'CCC': case 'CC': case 'C':
      inlineColorCredRate = '#ad033b'; break;
    case 'D':
      inlineColorCredRate = '#000000'; break;
  }
  return inlineColorCredRate
}

const HighchartsOptions = {
  // скрыть навигатор, скролбар и ссылку highcharts.com
  navigator: {
    enabled: false
  },
  scrollbar: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  chart: {
    type: 'scatter',
    zoomType: 'xy'
  },
  title: {
    text: 'Карта рынка',
  },
  yAxis: {
    title: {
      text: 'Доходность (YTM), %',
    }
  },
  tooltip: {
    backgroundColor: '#ffffff',
    hideDelay: 1500
  },

}

const durationChartBox = document.querySelector('.js-market_map_chart__duration')
const ytmChartBox = document.querySelector('.js-market_map_chart__ytm')

let chart_ytm = new Highcharts.Chart({chart: {renderTo: ytmChartBox},title: {text: 'Карта рынка'}})
let chart_duration = new Highcharts.Chart({chart: {renderTo: durationChartBox},title: {text: 'Карта рынка'}})

chart_ytm.showLoading('Загрузка')
chart_duration.showLoading('Загрузка')

const market_map_foo = () =>
{
  let oTable = $('.bonds__table').DataTable()
  oTable.on( 'draw', function () {
    let chartData = oTable.rows().data().toArray()
    let a_rate = [], a2_rate = [], b_rate = [], b2_rate = [], b3_rate = [], c_rate = [], d_rate = []

    chartData = sort_by_key(chartData, 'liquidity')

    const marketTip = document.querySelector('.js-market-tip')
    if (chartData.length > 200) {
      marketTip.innerHTML = '<br>Слишком много облигаций для отображения. Отображаются 200 наиболее ликвидных облигаций.'
    } else {
      marketTip.innerHTML = ''
    }

    chartData = chartData.slice(0, 200)

    for (let i=0; i<chartData.length; i++)
    {
      if (chartData[i].credit_rating_text == 'AAA' || chartData[i].credit_rating_text == 'AA')
      {
        a_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'A')
      {
        a2_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'BBB')
      {
        b_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'BB' || chartData[i].credit_rating_text == 'BB-')
      {
        b2_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'B' || chartData[i].credit_rating_text == 'B-' || chartData[i].credit_rating_text == 'B+')
      {
        b3_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'CCC' || chartData[i].credit_rating_text == 'CC' || chartData[i].credit_rating_text == 'C')
      {
        c_rate.push(chartData[i])
      }
      if (chartData[i].credit_rating_text == 'D')
      {
        d_rate.push(chartData[i])
      }
    }

    const durationOptions = {
      tooltip: {
        formatter () {
          // this.point.x is the timestamp in my original chartData array
          const marketMapPointData = chartData.find(row => row.price_return == this.point.y)
          const creditrating_text = (marketMapPointData.credit_rating_text != 'Array' && marketMapPointData.credit_rating_text != null ? marketMapPointData.credit_rating_text : 'n/a')
          const m_duration = (marketMapPointData.duration != null ? formatNumber(marketMapPointData.duration, 2) : formatNumber(marketMapPointData.mod_duration, 2));
          const yield_price_return = parseFloat(marketMapPointData.price_return)

          const marketMapTooltip = 'Название: <b>' + (marketMapPointData.shortname != null ? marketMapPointData.shortname : marketMapPointData.name) + '</b><br>' +
            'YTM: <b>' + formatNumber(yield_price_return, 1) + '</b><br>' +
            'Дюрация: <b>' + m_duration + '</b><br>' +
            'Рейтинг ДОХОДЪ: <b style="color:'+creditRatingTextColor(creditrating_text)+'">' + creditrating_text + '</b><br>' +
            'Качество: <b style="color:'+qualityColor(marketMapPointData.quality)+'">' + formatNumber(marketMapPointData.quality, 1) + '</b><br>'

          return marketMapTooltip
        }
      },
      xAxis: {
        title: {
          text: 'дюрация',
        }
      },
      series: [
        {
          name: 'AAA / AA',
          color: '#23dea8',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: a_rate.map(seriesDataDuration)
        },
        {
          name: 'A',
          color: '#3DEAB8',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: a2_rate.map(seriesDataDuration)
        },
        {
          name: 'BBB',
          color: '#c5efdd',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: b_rate.map(seriesDataDuration)
        },
        {
          name: 'BB / BB-',
          color: '#ccdff1',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: b2_rate.map(seriesDataDuration)
        },
        {
          name: 'B / B+ / B-',
          color: '#e8c9db',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: b3_rate.map(seriesDataDuration)
        },
        {
          name: 'CCC / CC / C',
          color: '#ad033b',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: c_rate.map(seriesDataDuration)
        },
        {
          name: 'D',
          color: '#000000',
          // array index 0 is the x value, index 1 is the y value in the chart
          data: d_rate.map(seriesDataDuration)
        },
      ],
    }

    const ytmOptions = {
      tooltip: {
        formatter () {
          // this.point.x is the timestamp in my original chartData array
          const marketMapPointData = chartData.find(row => row.price_return == this.point.y)
          const creditrating_text = (marketMapPointData.credit_rating_text != 'Array' && marketMapPointData.credit_rating_text != null ? marketMapPointData.credit_rating_text : 'n/a')
          const yield_price_return = parseFloat(marketMapPointData.price_return)

          const marketMapTooltip = 'Название: <b>' + (marketMapPointData.shortname != null ? marketMapPointData.shortname : marketMapPointData.name) + '</b><br>' +
            'YTM: <b>' + formatNumber(yield_price_return, 1) + '</b><br>' +
            'Срок: <b>' + formatNumber(marketMapPointData.years_to_maturity, 1) + '</b><br>' +
            'Рейтинг ДОХОДЪ: <b style="color:'+creditRatingTextColor(creditrating_text)+'">' + creditrating_text + '</b><br>' +
            'Качество: <b style="color:'+qualityColor(marketMapPointData.quality)+'">' + formatNumber(marketMapPointData.quality, 1) + '</b><br>'

          return marketMapTooltip
        }
      },
      xAxis: {
        title: {
          text: 'Срок до погашения',
        }
      },
      series: [
        {
          name: 'AAA / AA',
          color: '#23dea8',
          data: a_rate.map(seriesDataYTM)
        },
        {
          name: 'A',
          color: '#3DEAB8',
          data: a2_rate.map(seriesDataYTM)
        },
        {
          name: 'BBB',
          color: '#c5efdd',
          data: b_rate.map(seriesDataYTM)
        },
        {
          name: 'BB / BB-',
          color: '#ccdff1',
          data: b2_rate.map(seriesDataYTM)
        },
        {
          name: 'B / B+ / B-',
          color: '#e8c9db',
          data: b3_rate.map(seriesDataYTM)
        },
        {
          name: 'CCC / CC / C',
          color: '#ad033b',
          data: c_rate.map(seriesDataYTM)
        },
        {
          name: 'D',
          color: '#000000',
          data: d_rate.map(seriesDataYTM)
        },
      ],
    }

    for ( let i = 0; i < ytmOptions.series.length; i++)
    {
      ytmOptions.series[i].cursor = 'pointer'
      durationOptions.series[i].cursor = 'pointer'
      ytmOptions.series[i].dataLabels = {
        enabled: true,
          formatter () {
          const marketMapPointData = chartData.find(row => row.price_return == this.point.y)
            if (marketMapPointData !== undefined) {
              return marketMapPointData.name
            }
        },
      }
      durationOptions.series[i].dataLabels = {
        enabled: true,
        formatter () {
          const marketMapPointData = chartData.find(row => row.price_return == this.point.y)
          if (marketMapPointData !== undefined) {
            return marketMapPointData.name
          }
        },
      }
      ytmOptions.series[i].point = {
        events: {
          click: function () {
            const marketMapPointData = chartData.find(row => row.price_return == this.y)

            let dohodModal = document.getElementsByTagName('dohod-modal')
            if(dohodModal.length > 0) {
              dohodModal[0].remove()
            }
            let element = document.createElement('dohod-modal')
            document.body.appendChild(element)
            // Установка id для поиска компонента по нему
            element.setAttribute('isin', marketMapPointData.xml_isin)
            // Открытие модального окна
            element.setAttribute('opened', true)
            // Подписка на события
            element.addEventListener('close-modal', closeModal)
            element.addEventListener('open-modal', initModalComponents)
            return false;
          }
        }
      }
      durationOptions.series[i].point = {
        events: {
          click: function () {
            const marketMapPointData = chartData.find(row => row.price_return == this.y)

            let dohodModal = document.getElementsByTagName('dohod-modal')
            if(dohodModal.length > 0) {
              dohodModal[0].remove()
            }
            let element = document.createElement('dohod-modal')
            document.body.appendChild(element)
            // Установка id для поиска компонента по нему
            element.setAttribute('isin', marketMapPointData.xml_isin)
            // Открытие модального окна
            element.setAttribute('opened', true)
            // Подписка на события
            element.addEventListener('close-modal', closeModal)
            element.addEventListener('open-modal', initModalComponents)
          return false;
          }
        }
      }
    }

    chart_duration = Highcharts.chart(durationChartBox, durationOptions)
    chart_duration.update(HighchartsOptions)

    chart_ytm = Highcharts.chart(ytmChartBox, ytmOptions)
    chart_ytm.update(HighchartsOptions)
  })

// Новая модалка
// Инициализация компонента в модальном окне
  async function dataBinding(isin, element) {
    // Установка значений
    element.bonddata= await getBondByIsin(isin)
    element.otherbonds= await getIsinsByIssuer(isin, 1)
    element.bondsfeatures= await getBondsFeatures(isin)
    element.selectionOfReplacementItems= await getSelectionOfReplacement(isin, 1)
    element.iBondsIsinsList= null
    element.marketmap= await getSelectionOfReplacement(isin, 3)
    // Подписка на события
    element.addEventListener('open-modal', openModal)
    element.addEventListener('change-option', changeOption)
    element.addEventListener('change-replacement-filter', changeReplacementFilter)
    element.addEventListener('update-replacement-range', updateReplacementRange)
    return element
// Вызываем инициальные данные для заданного isin и передаем в компонент
  }
// Закрытие модального окна
  function closeModal () {
    let dohodModal = document.getElementsByTagName('dohod-modal')
    dohodModal[0].removeAttribute('opened')
  }
// Установка данных для компонента после открытия модального окна
  async function initModalComponents(payload) {
    // Получаем компонент и подписываемся на его изменения
    let bondElement= [...document.getElementsByTagName('bond-analysis')].find((el) => el.id === payload.detail)
    await dataBinding(payload.detail, bondElement)
  }
// Открытие модального окна
  async function openModal(payload) {
    let dohodModal = document.getElementsByTagName('dohod-modal')
    if(dohodModal.length > 0) {
      dohodModal[0].remove()
    }
    let element = document.createElement('dohod-modal')
    document.body.appendChild(element)
    // Установка id для поиска компонента по нему
    element.setAttribute('isin', payload.detail)
    // Открытие модального окна
    element.setAttribute('opened', true)
    // Подписка на события
    element.addEventListener('close-modal', closeModal)
    element.addEventListener('open-modal', initModalComponents)
  }
// Получения полных данных по облигации
  async function getBondByIsin(isin) {
    let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&isin=${ isin }`)
    return res.json()
  }
// Получения полных данных для вкладки Другие облигации
  async function getIsinsByIssuer(isin, option) {
    let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&isin=${ isin }&option=${ option }`)
    return res.json()
  }
// Смена опции для вкладки Другие облигации
  async function changeOption(event) {
    const option = event.detail[0]
    const element = event.srcElement
    const elementIsin = event.srcElement.bonddata.isin
    element.bondsdata = await getIsinsByIssuer(elementIsin, option)
  }
// Получение замен для Подбора замен
  async function getSelectionOfReplacement(isin, option) {
    try {
      const url =`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&replacement=1&option=${ option }`
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ isins: [isin] })
      })
      const json = await resp.json()
      return json[0].bonds
    } catch (e) {
      console.error(`Ошибка при получении данных для замены\n${ e }`)
      return []
    }
  }
// Получение IBond isins для Подбора замен
  async function getIBondsFromIsins(isinsArr, option) {
    try {
      const url = `/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&ibond=1&option=${ option }`
      const iBondsResponse = await fetch(url , {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ isins: isinsArr })
      })

      const json = await iBondsResponse .json()

      return json.isins
    } catch (e) {
      console.error(`Ошибка при получении данных для IBond\n${ e }`)
      return []
    }
  }

  async function updateReplacementRange(event) {
    const { selectedIBondsRange } = event.detail[0]
    const element = event.srcElement
    const replacementIsins = element.selectionOfReplacementItems.map(item => item.isin)
    element.iBondsIsinsList = await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value)
  }

  async function changeReplacementFilter(event) {
    const { filter, selectedIBondsRange } = event.detail[0]
    const element = event.srcElement
    const elementIsin = event.srcElement.bonddata.isin
    if(filter.index === 3) {
      const replacementIsins = element.selectionOfReplacementItems.map(item => item.isin)
      element.iBondsIsinsList = !filter.checked ? await getIBondsFromIsins(replacementIsins, selectedIBondsRange.value) : null
    } else {
      element.selectionOfReplacementItems = await getSelectionOfReplacement(elementIsin, filter.value)
    }
  }

  async function getBondsFeatures(isin) {
    let res = await fetch(`/assets/components/dohodbonds/connectorweb.php?action=getbondinfo&features=1&isin=${ isin }`)
    return res.json()
  }

}

export {market_map_foo}
